// Константы для Mercantile Brace (polunio16, models/mercantilebrace__1_0_0.cfc)
// Значения извлечены из models/mercantilebrace__1_0_0.json

export const MB_STATES = [
  { value: 'FL', label: 'Florida' },
  { value: 'GA', label: 'Georgia (GL only)' },
  { value: 'AL', label: 'Alabama (GL only)' },
  { value: 'LA', label: 'Louisiana (Property only)' }
];

export const MB_RATE_TYPES = [
  { value: 'NB', label: 'New Business' },
  { value: 'RN', label: 'Renewal' }
];

// lineProperty.County
export const MB_COUNTIES = {
  FL: [
    'Alachua', 'Baker', 'Bay', 'Bradford', 'Brevard', 'Broward', 'Calhoun', 'Charlotte',
    'Citrus', 'Clay', 'Collier', 'Columbia', 'De Soto', 'Dixie', 'Duval', 'Escambia',
    'Flagler', 'Franklin', 'Gadsden', 'Gilchrist', 'Glades', 'Gulf', 'Hamilton', 'Hardee',
    'Hendry', 'Hernando', 'Highlands', 'Hillsborough', 'Holmes', 'Indian River', 'Jackson',
    'Jefferson', 'Lafayette', 'Lake', 'Lee', 'Leon', 'Levy', 'Liberty', 'Madison', 'Manatee',
    'Marion', 'Martin', 'Miami-Dade', 'Monroe', 'Nassau', 'Okaloosa', 'Okeechobee', 'Orange',
    'Osceola', 'Palm Beach', 'Pasco', 'Pinellas', 'Polk', 'Putnam', 'Saint Johns',
    'Saint Lucie', 'Santa Rosa', 'Sarasota', 'Seminole', 'Sumter', 'Suwannee', 'Taylor',
    'Union', 'Volusia', 'Wakulla', 'Walton', 'Washington'
  ],
  LA: [
    'Acadia', 'Allen', 'Ascension', 'Assumption', 'Avoyelles', 'Beauregard', 'Bienville',
    'Bossier', 'Caddo', 'Calcasieu', 'Caldwell', 'Cameron', 'Catahoula', 'Claiborne',
    'Concordia', 'De Soto', 'East Baton Rouge', 'East Carroll', 'East Feliciana',
    'Evangeline', 'Franklin', 'Grant', 'Iberia', 'Iberville', 'Jackson', 'Jefferson Davis',
    'Jefferson', 'La Salle', 'Lafayette', 'Lafourche', 'Lincoln', 'Livingston', 'Madison',
    'Morehouse', 'Natchitoches', 'Orleans', 'Ouachita', 'Plaquemines', 'Pointe Coupee',
    'Rapides', 'Red River', 'Richland', 'Sabine', 'Saint Bernard', 'Saint Charles',
    'Saint Helena', 'Saint James', 'Saint Landry', 'Saint Martin', 'Saint Mary',
    'Saint Tammany', 'St John the Baptist', 'Tangipahoa', 'Tensas', 'Terrebonne', 'Union',
    'Vermilion', 'Vernon', 'Washington', 'Webster', 'West Baton Rouge', 'West Carroll',
    'West Feliciana', 'Winn'
  ]
};

// lineProperty.constructionType
export const MB_CONSTRUCTION_TYPES = [
  { value: 'Frame', label: 'Frame' },
  { value: 'O', label: 'Other (O)' },
  { value: 'JM', label: 'Joisted Masonry (JM)' },
  { value: 'NC', label: 'Non-Combustible (NC)' },
  { value: 'M-NC', label: 'Masonry Non-Combustible (M-NC)' },
  { value: 'F-R', label: 'Fire Resistive (F-R)' },
  { value: 'MFR', label: 'Modified Fire Resistive (MFR)' }
];

// lineProperty.NonWindBaseRate — ключи occupancy
export const MB_OCCUPANCIES = [
  { value: 'Apartments', label: 'Apartments' },
  { value: 'Condos', label: 'Condos' },
  { value: 'Co-ops', label: 'Co-ops' },
  { value: 'Townhouse', label: 'Townhouse' },
  { value: 'Mercantile', label: 'Mercantile' },
  { value: 'Mercantile LRO (non-manufacturing)', label: 'Mercantile LRO (non-manufacturing)' },
  { value: 'Hotels', label: 'Hotels' },
  { value: 'Motels', label: 'Motels' },
  { value: 'Other', label: 'Other' }
];

export const MB_PROTECTION_CLASSES = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(v => ({
  value: String(v),
  label: String(v)
}));

// lineProperty.WindBaseRate — ключи distance to coast
export const MB_DISTANCE_TO_COAST = [
  { value: '0 - 0.5 Mile', label: '0 - 0.5 Mile' },
  { value: '0.5 - 1 Mile', label: '0.5 - 1 Mile' },
  { value: '1 - 2 Miles', label: '1 - 2 Miles' },
  { value: '2 - 5 Miles', label: '2 - 5 Miles' },
  { value: 'between 5 and 10 miles', label: 'Between 5 and 10 Miles' },
  { value: '>10 but <30 miles', label: '>10 but <30 Miles' },
  { value: '>30 miles', label: '>30 Miles' }
];

// lineProperty.ALLACovItemTypes2RateMethods — типы покрытий
export const MB_COVERAGE_TYPES = [
  { value: 'Building', label: 'Building' },
  { value: 'Building A&A', label: 'Building A&A' },
  { value: 'Contents', label: 'Contents' },
  { value: 'Business Income With Extra Expense', label: 'Business Income With Extra Expense' },
  { value: 'Business Income without Extra Expense', label: 'Business Income without Extra Expense (-5%)' },
  { value: 'Extra Expense', label: 'Extra Expense' },
  { value: 'Tenant Glass', label: 'Tenant Glass (frame rate, min $100)' },
  { value: 'Stained Glass', label: 'Stained Glass (frame rate, min $100)' },
  { value: 'Sign attached to building', label: 'Sign attached to building (0.03, min $250)' },
  { value: 'Detached Sign', label: 'Detached Sign (0.03, min $250)' },
  { value: 'Outdoor Property', label: 'Outdoor Property (frame rate)' },
  { value: 'Tennis Court', label: 'Tennis Court (frame rate)' },
  { value: 'Playground equipment', label: 'Playground equipment (frame rate)' },
  { value: 'Irrigation system', label: 'Irrigation system (frame rate)' },
  { value: 'Shuffleboard court', label: 'Shuffleboard court (frame rate)' },
  { value: 'Heating &  A/C Units', label: 'Heating & A/C Units (frame rate)' },
  { value: 'Mailboxes', label: 'Mailboxes (frame rate)' },
  { value: 'Landscape lighting', label: 'Landscape lighting (frame rate)' },
  { value: 'Entrance Wall & gate', label: 'Entrance Wall & gate (frame rate)' },
  { value: 'Gates', label: 'Gates (frame rate)' },
  { value: 'Wall', label: 'Wall (frame rate)' },
  { value: 'Swimming Pool', label: 'Swimming Pool (frame rate)' },
  { value: 'Canopies', label: 'Canopies (frame rate)' },
  { value: 'Pole', label: 'Pole (frame rate)' },
  { value: 'Fence', label: 'Fence (frame rate)' },
  { value: 'Gas pumps', label: 'Gas pumps (frame rate)' }
];

// lineProperty.PropDeductible
export const MB_PROP_DEDUCTIBLES = [
  { value: 1000, label: '$1,000' },
  { value: 2500, label: '$2,500' },
  { value: 5000, label: '$5,000' },
  { value: 10000, label: '$10,000' },
  { value: 15000, label: '$15,000' },
  { value: 25000, label: '$25,000' },
  { value: 50000, label: '$50,000' }
];

// lineProperty.CauseOfLossCredit (Basic = 0.9, остальные = 1)
export const MB_CAUSE_OF_LOSS = [
  { value: 'Basic', label: 'Basic' },
  { value: 'Broad', label: 'Broad' },
  { value: 'Special', label: 'Special' }
];

// lineProperty.WindHailDeductible / windDeductibleMinimum
export const MB_WIND_DEDUCTIBLES = [
  { value: '2%', label: '2%' },
  { value: '3%', label: '3%' },
  { value: '5%', label: '5%' },
  { value: '10%', label: '10%' }
];

export const MB_WIND_DED_OPTIONS = [
  { value: 'Hurricane', label: 'Hurricane' },
  { value: 'Named Windstorm', label: 'Named Windstorm' }
];

// lineProperty.ShuttersCredit
export const MB_SHUTTERS = [
  { value: '', label: 'None' },
  { value: '1 - All openings designed for large missiles', label: '1 - All openings designed for large missiles' },
  { value: '2 - All openings designed for medium missiles', label: '2 - All openings designed for medium missiles' },
  { value: '3 - All openings designed for small missiles', label: '3 - All openings designed for small missiles' }
];

// lineProperty.BuildingVacancy (не выбрано = фактор 1)
export const MB_VACANCY = [
  { value: '', label: 'Occupied (31% or more)' },
  { value: 'Less than 31% occupied/used', label: 'Less than 31% occupied/used' },
  { value: 'Completely Vacant', label: 'Completely Vacant' }
];

// lineProperty.Cooking_PrcBuildingInhabited
export const MB_COOKING_PBI = [
  { value: 'Less than 25%', label: 'Less than 25%' },
  { value: '25% to 49%', label: '25% to 49%' },
  { value: '50% or more', label: '50% or more' }
];

// lineGL.ilf — валидные комбинации Occurrence/Aggregate лимитов
export const MB_GL_LIMIT_COMBINATIONS = [
  { perOccurrence: 100000, aggregate: 100000, label: '$100,000 / $100,000' },
  { perOccurrence: 100000, aggregate: 200000, label: '$100,000 / $200,000' },
  { perOccurrence: 300000, aggregate: 300000, label: '$300,000 / $300,000' },
  { perOccurrence: 300000, aggregate: 600000, label: '$300,000 / $600,000' },
  { perOccurrence: 500000, aggregate: 500000, label: '$500,000 / $500,000' },
  { perOccurrence: 500000, aggregate: 1000000, label: '$500,000 / $1,000,000' },
  { perOccurrence: 1000000, aggregate: 1000000, label: '$1,000,000 / $1,000,000' },
  { perOccurrence: 1000000, aggregate: 2000000, label: '$1,000,000 / $2,000,000' }
];

// lineGL.deductibles — допустимые значения BI/PD
export const MB_GL_DEDUCTIBLE_VALUES = [
  0, 250, 500, 750, 1000, 2000, 3000, 4000, 5000,
  10000, 15000, 20000, 25000, 50000, 75000, 100000
].map(v => ({ value: v, label: v === 0 ? 'None' : '$' + v.toLocaleString('en-US') }));

// lineGL.ai — формы Additional Insured
export const MB_AI_FORMS = [
  { value: 'CG2002', label: 'CG2002 - Club Members (included)' },
  { value: 'CG2003', label: 'CG2003 - Concessionaires ($50)' },
  { value: 'CG2004', label: 'CG2004 - Condo Owners ($50)' },
  { value: 'CG2005', label: 'CG2005 - Controlling Interest ($50)' },
  { value: 'CG2007', label: 'CG2007 - Engineers, Architects, or Surveyors ($50)' },
  { value: 'CG2008', label: 'CG2008 - Users of Golfmobiles ($50)' },
  { value: 'CG2010', label: 'CG2010 - Owners/Lessors/Contractors ($50)' },
  { value: 'CG2011', label: 'CG2011 - Managers/Lessors ($50)' },
  { value: 'CG2012', label: 'CG2012 - State or Political Subdivisions - Permits Issued ($50)' },
  { value: 'CG2015', label: 'CG2015 - Vendors ($50)' },
  { value: 'CG2017', label: 'CG2017 - Townhouse Associations (included)' },
  { value: 'CG2018', label: 'CG2018 - Mortgagee/Assignee/Receiver (included)' },
  { value: 'CG2020', label: 'CG2020 - Charitable Institutions (included)' },
  { value: 'CG2021', label: 'CG2021 - Volunteer Workers ($50)' },
  { value: 'CG2022', label: 'CG2022 - Church Members And Officers (included)' },
  { value: 'CG2024', label: 'CG2024 - Owners From Whom Land Has Been Leased (included)' },
  { value: 'CG2026', label: 'CG2026 - Designated Person or Organization ($50)' },
  { value: 'CG2027', label: 'CG2027 - Co-Owners of Insured Premises (included)' },
  { value: 'CG2028', label: 'CG2028 - Lessor of Leased Equipment ($50)' },
  { value: 'CG2029', label: 'CG2029 - Grantor of Franchise ($50)' },
  { value: 'CG2404A', label: 'CG2404A - Blanket Waiver of Subrogation ($250)' },
  { value: 'CG2503', label: 'CG2503 - Project Aggregate ($150)' },
  { value: 'CG2504', label: 'CG2504 - Location Aggregate ($150)' },
  { value: 'EPNC0210', label: 'EPNC0210 - Primary Non-Contrib ($150)' },
  { value: 'SL0130', label: 'SL0130 - Automatic Additional Insureds Endorsement ($150, automatic)' }
];

// lineGL.cc — класс-коды (FL/GA/AL совпадают, кроме 15600 — только в AL)
export const MB_GL_CLASS_CODES = [
  { value: 10010, label: '10010 (basis: Gross Sales / 1000)' },
  { value: 10026, label: '10026 (basis: Gross Sales / 1000)' },
  { value: 10040, label: '10040 (basis: Gross Sales / 1000)' },
  { value: 10042, label: '10042 (basis: Gross Sales / 1000)' },
  { value: 10060, label: '10060 (basis: Gross Sales / 1000)' },
  { value: 10065, label: '10065 (basis: Gross Sales / 1000)' },
  { value: 10066, label: '10066 (basis: Gross Sales / 1000)' },
  { value: 10073, label: '10073 (basis: Gross Sales / 1000)' },
  { value: 10100, label: '10100 (basis: Gross Sales / 1000)' },
  { value: 10111, label: '10111 (basis: Gross Sales / 1000)' },
  { value: 10113, label: '10113 (basis: T-number of operators)' },
  { value: 10115, label: '10115 (basis: T-number of operators)' },
  { value: 10145, label: '10145 (basis: Gross Sales / 1000)' },
  { value: 10204, label: '10204 (basis: Gross Sales / 1000)' },
  { value: 10205, label: '10205 (basis: Gross Sales / 1000)' },
  { value: 10255, label: '10255 (basis: Gross Sales / 1000)' },
  { value: 10257, label: '10257 (basis: Gross Sales / 1000)' },
  { value: 10309, label: '10309 (basis: Gross Sales / 1000)' },
  { value: 10315, label: '10315 (basis: Gross Sales / 1000)' },
  { value: 10352, label: '10352 (basis: Gross Sales / 1000)' },
  { value: 10367, label: '10367 (basis: Gross Sales / 1000)' },
  { value: 10368, label: '10368 (basis: Gross Sales / 1000)' },
  { value: 11007, label: '11007 (basis: Gross Sales / 1000)' },
  { value: 11039, label: '11039 (basis: Gross Sales / 1000)' },
  { value: 11126, label: '11126 (basis: Gross Sales / 1000)' },
  { value: 11127, label: '11127 (basis: Gross Sales / 1000)' },
  { value: 11128, label: '11128 (basis: Gross Sales / 1000)' },
  { value: 11155, label: '11155 (basis: Gross Sales / 1000)' },
  { value: 11222, label: '11222 (basis: Gross Sales / 1000)' },
  { value: 11288, label: '11288 (basis: Gross Sales / 1000)' },
  { value: 12361, label: '12361 (basis: Gross Sales / 1000)' },
  { value: 12362, label: '12362 (basis: Gross Sales / 1000)' },
  { value: 12393, label: '12393 (basis: Gross Sales / 1000)' },
  { value: 12467, label: '12467 (basis: Gross Sales / 1000)' },
  { value: 12509, label: '12509 (basis: Gross Sales / 1000)' },
  { value: 12510, label: '12510 (basis: Gross Sales / 1000)' },
  { value: 12651, label: '12651 (basis: Gross Sales / 1000)' },
  { value: 12797, label: '12797 (basis: Gross Sales / 1000)' },
  { value: 12805, label: '12805 (basis: Gross Sales / 1000)' },
  { value: 12841, label: '12841 (basis: Gross Sales / 1000)' },
  { value: 13049, label: '13049 (basis: Gross Sales / 1000)' },
  { value: 13111, label: '13111 (basis: Gross Sales / 1000)' },
  { value: 13112, label: '13112 (basis: Gross Sales / 1000)' },
  { value: 13351, label: '13351 (basis: Gross Sales / 1000)' },
  { value: 13352, label: '13352 (basis: Gross Sales / 1000)' },
  { value: 13506, label: '13506 (basis: Gross Sales / 1000)' },
  { value: 13507, label: '13507 (basis: Gross Sales / 1000)' },
  { value: 13670, label: '13670 (basis: Gross Sales / 1000)' },
  { value: 13673, label: '13673 (basis: Gross Sales / 1000)' },
  { value: 13716, label: '13716 (basis: Gross Sales / 1000)' },
  { value: 13720, label: '13720 (basis: Gross Sales / 1000)' },
  { value: 13759, label: '13759 (basis: Gross Sales / 1000)' },
  { value: 13930, label: '13930 (basis: Gross Sales / 1000)' },
  { value: 14101, label: '14101 (basis: Gross Sales / 1000)' },
  { value: 14279, label: '14279 (basis: Gross Sales / 1000)' },
  { value: 14401, label: '14401 (basis: Gross Sales / 1000)' },
  { value: 14405, label: '14405 (basis: Gross Sales / 1000)' },
  { value: 14527, label: '14527 (basis: Gross Sales / 1000)' },
  { value: 14655, label: '14655 (basis: Gross Sales / 1000)' },
  { value: 14732, label: '14732 (basis: Gross Sales / 1000)' },
  { value: 14733, label: '14733 (basis: Gross Sales / 1000)' },
  { value: 15070, label: '15070 (basis: Gross Sales / 1000)' },
  { value: 15223, label: '15223 (basis: Gross Sales / 1000)' },
  { value: 15224, label: '15224 (basis: Gross Sales / 1000)' },
  { value: 15488, label: '15488 (basis: Gross Sales / 1000)' },
  { value: 15538, label: '15538 (basis: Gross Sales / 1000)' },
  { value: 15600, label: '15600 (basis: T-number of operators) [AL only]' },
  { value: 15608, label: '15608 (basis: Gross Sales / 1000)' },
  { value: 15699, label: '15699 (basis: Gross Sales / 1000)' },
  { value: 15839, label: '15839 (basis: Gross Sales / 1000)' },
  { value: 15991, label: '15991 (basis: Gross Sales / 1000)' },
  { value: 15993, label: '15993 (basis: Gross Sales / 1000)' },
  { value: 16005, label: '16005 (basis: Gross Sales / 1000)' },
  { value: 16471, label: '16471 (basis: Gross Sales / 1000)' },
  { value: 16527, label: '16527 (basis: Gross Sales / 1000)' },
  { value: 16588, label: '16588 (basis: Gross Sales / 1000)' },
  { value: 16676, label: '16676 (basis: Gross Sales / 1000)' },
  { value: 16705, label: '16705 (basis: Gross Sales / 1000)' },
  { value: 16722, label: '16722 (basis: Gross Sales / 1000)' },
  { value: 16750, label: '16750 (basis: Gross Sales / 1000)' },
  { value: 16819, label: '16819 (basis: Gross Sales / 1000)' },
  { value: 16820, label: '16820 (basis: Gross Sales / 1000)' },
  { value: 16900, label: '16900 (basis: Gross Sales / 1000)' },
  { value: 16901, label: '16901 (basis: Gross Sales / 1000)' },
  { value: 16902, label: '16902 (basis: Gross Sales / 1000)' },
  { value: 16910, label: '16910 (basis: Gross Sales / 1000)' },
  { value: 16911, label: '16911 (basis: Gross Sales / 1000)' },
  { value: 18078, label: '18078 (basis: Gross Sales / 1000)' },
  { value: 18109, label: '18109 (basis: Gross Sales / 1000)' },
  { value: 18110, label: '18110 (basis: Gross Sales / 1000)' },
  { value: 18335, label: '18335 (basis: Gross Sales / 1000)' },
  { value: 18437, label: '18437 (basis: Gross Sales / 1000)' },
  { value: 18501, label: '18501 (basis: Gross Sales / 1000)' },
  { value: 18506, label: '18506 (basis: Gross Sales / 1000)' },
  { value: 18507, label: '18507 (basis: Gross Sales / 1000)' },
  { value: 18833, label: '18833 (basis: Gross Sales / 1000)' },
  { value: 18911, label: '18911 (basis: Gross Sales / 1000)' },
  { value: 18912, label: '18912 (basis: Gross Sales / 1000)' },
  { value: 18991, label: '18991 (basis: Gross Sales / 1000)' },
  { value: 41603, label: '41603 (basis: T-each acre)' },
  { value: 41604, label: '41604 (basis: T-each acre)' },
  { value: 41650, label: '41650 (basis: Area / 1000)' },
  { value: 41668, label: '41668 (basis: Area / 1000)' },
  { value: 41696, label: '41696 (basis: Gross Sales / 1000)' },
  { value: 41697, label: '41697 (basis: Gross Sales / 1000)' },
  { value: 43889, label: '43889 (basis: Gross Sales / 1000)' },
  { value: 44069, label: '44069 (basis: Gross Sales / 1000)' },
  { value: 45901, label: '45901 (basis: Gross Sales / 1000)' },
  { value: 45937, label: '45937 (basis: Gross Sales / 1000)' },
  { value: 46004, label: '46004 (basis: Area / 1000)' },
  { value: 46005, label: '46005 (basis: Area / 1000)' },
  { value: 46426, label: '46426 (basis: Area / 1000)' },
  { value: 46427, label: '46427 (basis: Area / 1000)' },
  { value: 46604, label: '46604 (basis: Gross Sales / 1000)' },
  { value: 46606, label: '46606 (basis: Area / 1000)' },
  { value: 46607, label: '46607 (basis: Area / 1000)' },
  { value: 46622, label: '46622 (basis: Area / 1000)' },
  { value: 47367, label: '47367 (basis: Payroll / 1000)' },
  { value: 48925, label: '48925 (basis: T-each pool)' },
  { value: 49617, label: '49617 (basis: Gross Sales / 1000)' },
  { value: 49763, label: '49763 (basis: Gross Sales / 1000)' },
  { value: 51315, label: '51315 (basis: Gross Sales / 1000)' },
  { value: 58408, label: '58408 (basis: Gross Sales / 1000)' },
  { value: 58409, label: '58409 (basis: Gross Sales / 1000)' },
  { value: 60010, label: '60010 (basis: Units)' },
  { value: 60011, label: '60011 (basis: Units)' },
  { value: 61212, label: '61212 (basis: Area / 1000)' },
  { value: 61216, label: '61216 (basis: Area / 1000)' },
  { value: 61217, label: '61217 (basis: Area / 1000)' },
  { value: 61218, label: '61218 (basis: Area / 1000)' },
  { value: 61223, label: '61223 (basis: Area / 1000)' },
  { value: 61224, label: '61224 (basis: Area / 1000)' },
  { value: 61225, label: '61225 (basis: Area / 1000)' },
  { value: 61226, label: '61226 (basis: Area / 1000)' },
  { value: 61227, label: '61227 (basis: Area / 1000)' },
  { value: 62000, label: '62000 (basis: Area / 1000)' },
  { value: 62001, label: '62001 (basis: Area / 1000)' },
  { value: 62002, label: '62002 (basis: Area / 1000)' },
  { value: 62003, label: '62003 (basis: Units)' },
  { value: 63010, label: '63010 (basis: T-each dwelling)' },
  { value: 63011, label: '63011 (basis: T-each dwelling)' },
  { value: 63012, label: '63012 (basis: T-each dwelling)' },
  { value: 63013, label: '63013 (basis: T-each dwelling)' },
  { value: 65007, label: '65007 (basis: Area / 1000)' },
  { value: 66122, label: '66122 (basis: Area / 1000)' },
  { value: 66123, label: '66123 (basis: Area / 1000)' },
  { value: 66309, label: '66309 (basis: Area / 1000)' },
  { value: 66561, label: '66561 (basis: Area / 1000)' },
  { value: 67635, label: '67635 (basis: Area / 1000)' },
  { value: 68604, label: '68604 (basis: Area / 1000)' },
  { value: 68606, label: '68606 (basis: Area / 1000)' },
  { value: 68607, label: '68607 (basis: Area / 1000)' },
  { value: 68702, label: '68702 (basis: Area / 1000)' },
  { value: 68703, label: '68703 (basis: Area / 1000)' },
  { value: 68706, label: '68706 (basis: Area / 1000)' },
  { value: 68707, label: '68707 (basis: Area / 1000)' },
  { value: 91555, label: '91555 (basis: Payroll / 1000)' },
  { value: 91583, label: '91583 (basis: Total Cost / 1000)' },
  { value: 91585, label: '91585 (basis: Total Cost / 1000)' },
  { value: 99917, label: '99917 (basis: Payroll / 1000)' },
  { value: 99938, label: '99938 (basis: Payroll / 1000)' },
];
